import React from 'react'

//hooks
import UseDraftsScreen from './DraftsScreen.hooks';

//commponents
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable'
import NotificationBar from  '@/components/elements/languages/NotificationBar';

//interfaces
import { ITableContent } from  '@/interfaces/simpleTable';

//styling
import "../../../../css/content/drafts.scss"



const DraftsScreen = ({appId}: {appId: string}) => {  
    const { pageTitle, publishAllButton, publishAllButtonLabel, onPublishAllDrafts, showSimpleTable, tableContent, noDataMessage, updateDrafts, notificationDetails, disablePublishAll, moreAvailable, isLoading} = UseDraftsScreen(appId);

    return(
        <div className="content-drafts-screen" >
            <div className='drafts-top-panel'>
                <h1>{pageTitle}</h1>
                <BasicButton className='publish-all-button' content={publishAllButton} ariaLabel={publishAllButtonLabel} onButtonClick={onPublishAllDrafts} isDisabled={disablePublishAll}/>
            </div>
            
            {showSimpleTable && <SimpleTable simpleTableContent={tableContent as ITableContent} isInfiniteScroll={true} getMoreContent={updateDrafts} noDataMessage={noDataMessage} infiniteScrollFetchCondition={moreAvailable} isLoading={isLoading}/>}

            <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
        </div>
    )
}

export default  DraftsScreen